import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusSquare } from '@fortawesome/free-regular-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function DeleteRowButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faMinusSquare} />}
    />
  );
}

DeleteRowButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DeleteRowButton.defaultProps = {
  content: 'Видалити',
  disabled: false,
};

export default DeleteRowButton;
